
export class FileShareDiscoveryRangeModel {
  beginIp: string;
  endIp: string;
  interval: string;
}
